import React, { Component } from 'react';
import { GetTitleAndMetaTags } from '../../Code/Data';
import { Helmet } from 'react-helmet';

export default class TitleAndMetaTags extends Component {
  constructor() {
    super();
    this.state = { title: '', keywords: '', description: '', robots: '' }
  }

  async componentDidMount() {
    const tmt = await GetTitleAndMetaTags(this.props.pageName);
    this.setState({
      title: tmt.PageTitle,
      keywords: tmt.Keywords,
      description: tmt.Description,
      robots: tmt.Robots
    });
  }

  render() {
    return <Helmet>
      <meta name="keywords" content={this.state.keywords} />
      <meta name="description" content={this.state.description} />
      <meta name="robots" content={this.state.robots} />
      <title>{this.state.title}</title>
    </Helmet>;
  }
}
